/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getBobbinPrintInfo } from '../fn/print-label/get-bobbin-print-info';
import { GetBobbinPrintInfo$Params } from '../fn/print-label/get-bobbin-print-info';
import { getPrintInfo } from '../fn/print-label/get-print-info';
import { GetPrintInfo$Params } from '../fn/print-label/get-print-info';
import { LabelPrintInfo } from '../models/label-print-info';
import { printBobbinLabel } from '../fn/print-label/print-bobbin-label';
import { PrintBobbinLabel$Params } from '../fn/print-label/print-bobbin-label';
import { printLabel } from '../fn/print-label/print-label';
import { PrintLabel$Params } from '../fn/print-label/print-label';

@Injectable({ providedIn: 'root' })
export class PrintLabelService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `printBobbinLabel()` */
  static readonly PrintBobbinLabelPath = '/api/v1/PrintLabel/{producedMaterialId}/bobbin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `printBobbinLabel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  printBobbinLabel$Response(params: PrintBobbinLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return printBobbinLabel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `printBobbinLabel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  printBobbinLabel(params: PrintBobbinLabel$Params, context?: HttpContext): Observable<void> {
    return this.printBobbinLabel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `printLabel()` */
  static readonly PrintLabelPath = '/api/v1/PrintLabel/{productionOrderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `printLabel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  printLabel$Response(params: PrintLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return printLabel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `printLabel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  printLabel(params: PrintLabel$Params, context?: HttpContext): Observable<void> {
    return this.printLabel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBobbinPrintInfo()` */
  static readonly GetBobbinPrintInfoPath = '/api/v1/PrintLabel/{productionOrderId}/bobbin/PrintInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBobbinPrintInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBobbinPrintInfo$Response(params: GetBobbinPrintInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<LabelPrintInfo>> {
    return getBobbinPrintInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBobbinPrintInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBobbinPrintInfo(params: GetBobbinPrintInfo$Params, context?: HttpContext): Observable<LabelPrintInfo> {
    return this.getBobbinPrintInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<LabelPrintInfo>): LabelPrintInfo => r.body)
    );
  }

  /** Path part for operation `getPrintInfo()` */
  static readonly GetPrintInfoPath = '/api/v1/PrintLabel/{productionOrderId}/PrintInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrintInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrintInfo$Response(params: GetPrintInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<LabelPrintInfo>> {
    return getPrintInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrintInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrintInfo(params: GetPrintInfo$Params, context?: HttpContext): Observable<LabelPrintInfo> {
    return this.getPrintInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<LabelPrintInfo>): LabelPrintInfo => r.body)
    );
  }

}
